import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatDistanceToNow } from "date-fns";

const JobDetailModal = ({ show, onHide, job }) => {
  if (!job) return null;
  const formatDate = (date) => {
    if (!date) return "N/A";
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Job Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Job Id:</strong> {job.jobId}
        </p>
        <p>
          <strong>Title:</strong> {job.title}
        </p>
        <p>
          <strong>Openings:</strong> {job.openings}
        </p>
        <p>
          <strong>City:</strong> {job.city}
        </p>
        <p>
          <strong>Date:</strong>{" "}
          {new Date(job.date).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </p>

        <p>
          <strong>Created By Email:</strong>{" "}
          {job.createdBy ? job.createdBy.user_email : "-"}
        </p>

        <p>
          <strong>Status:</strong> {job.status}
        </p>
        <p>
          <strong>Comment:</strong> {job.comment}
        </p>
        <p>
          <strong>Job Posting Details:</strong> {job.postingdetails}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default JobDetailModal;
